<template>
  <div class="info-wrapper">
    <img class="info-wrapper" :src="textData.img">
    <div ref="move" :class="moveClass">
      <div class="service_p">
        <h2>{{textData.title}}</h2>
        <p class="fnt_24">{{textData.content}}</p>
      </div>
      <div class="down">
        <div class="child" v-for="(item, index) in contentData" :key="index">
          <img :src="item.img" />
        </div>
<!--        <div class="child">-->
<!--          <img src="../../../static/images/firstPage/icon/2.png" />-->
<!--        </div>-->
<!--        <div class="child">-->
<!--          <img src="../../../static/images/firstPage/icon/3.png" />-->
<!--        </div>-->
<!--        <div class="child">-->
<!--          <img src="../../../static/images/firstPage/icon/4.png" />-->
<!--        </div>-->
<!--        <div class="child">-->
<!--          <img src="../../../static/images/firstPage/icon/1.png" />-->
<!--        </div>-->
<!--        <div class="child">-->
<!--          <img src="../../../static/images/firstPage/icon/2.png" />-->
<!--        </div>-->
<!--        <div class="child">-->
<!--          <img src="../../../static/images/firstPage/icon/3.png" />-->
<!--        </div>-->
<!--        <div class="child">-->
<!--          <img src="../../../static/images/firstPage/icon/4.png" />-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      moveClass: 'data-text move-before',
      textData: {},
      contentData: []
    }
  },
  methods: {
  },
  mounted: function () {
    if (this.$boss) {
      this.textData = this.$boss.page151.g151[0]
      this.contentData = this.$boss.page515.g515.reverse().slice(0, 16)
    }
  }
}
</script>
<style scoped lang="less">
  .info-wrapper {
    width: 100%;
    height: 100%;
    /*background: url("../../../static/images/firstPage/serviceCustomer.png") no-repeat;*/
    background-size: 100% 100%;
  }
@media screen and (max-width: 1900px) {
  .data-text {
    color: #323232;
    position: absolute;
    left: 200px;
    top: 15%;
    text-align: left;
    width: 100%;
    z-index: 999;
    transition: all 1.5s;
    -webkit-transition: all 1.5s;
  }
  .move-before{
    transform: translate(0,-50%);
    -webkit-transform: translate(0,-50%);
    -ms-transform: translate(0,-50%);
    opacity: 0;

  }

  .move-after{
    transform: translate(-100px,-50%);
    -webkit-transform: translate(-100px,-50%);
    -ms-transform: translate(-100px,-50%);
    opacity: 1;
  }

  .service_p {
    flex: 1
  }
  .service_p h2, .service_p p {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .service_p p {
    font-size: 22px;
    margin-top: 0;
    color: #72899b;
  }
  .service_p h2 {
    font-size: 36px;
    margin-bottom: 5px;
    line-height: 60px;
    max-height: 120px;
  }
  .down {
    display: flex;
    position: absolute;
    flex-wrap: wrap;
    width: 90%;
    /*margin-top: 1%;*/
    .child {
      /*margin-top: 10px;*/
      width: 25%;
      /*margin-right: 1%;*/
      img {
        width: 100%;
      }
      img:hover {
        transform: scale(1.1);
      }
    }
  }
}
@media screen and (min-width: 1901px) {
  /*.info-wrapper {*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*  background: url("../../../static/images/firstPage/serviceCustomer.png") no-repeat;*/
  /*  background-size: 100% 100%;*/
  /*}*/

  .data-text {
    color: #323232;
    position: absolute;
    left: 200px;
    top: 12%;
    text-align: left;
    width: 100%;
    z-index: 999;
    transition: all 1.5s;
    -webkit-transition: all 1.5s;
  }
  .move-before{
    transform: translate(0,-50%);
    -webkit-transform: translate(0,-50%);
    -ms-transform: translate(0,-50%);
    opacity: 0;

  }

  .move-after{
    transform: translate(-100px,-50%);
    -webkit-transform: translate(-100px,-50%);
    -ms-transform: translate(-100px,-50%);
    opacity: 1;
  }

  .service_p {
    flex: 1
  }
  .service_p h2, .service_p p {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .service_p p {
    font-size: 24px;
    color: #72899b;
  }
  .service_p h2 {
    font-size: 42px;
    line-height: 60px;
    margin-bottom: -15px;
    max-height: 120px;
  }
  .down {
    display: flex;
    position: absolute;
    flex-wrap: wrap;
    width: 90%;
    /*margin-top: 1%;*/
    .child {
      /*margin-top: 20px;*/
      width: 25%;
      /*margin-right: 1%;*/
      img {
        width: 100%;
      }
      img:hover {
        transform: scale(1.05);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/serviceCustomer.vue